import React, { useState } from "react";
import "../style/header.css"; // Import the CSS file
import CompanyLogo from "../assets/Logo.png"; // Assuming this path is correct
import HamburgerIconImg from "../assets/menu-burger.png"; // Assuming this path is correct

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage menu open/close

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the state
  };

  // Function to handle smooth scrolling
  const handleNavLinkClick = (event, sectionId) => {
    event.preventDefault(); // Prevent the default jump behavior of the anchor tag

    const targetElement = document.getElementById(sectionId); // Get the element by its ID
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth", // Smooth scroll animation
        block: "start", // Align the top of the element with the top of the viewport
      });
      setIsMenuOpen(false); // Close the mobile menu after clicking a link
    }
  };

  return (
    <header className="header-container">
      <div className="header-main-row">
        <div className="header-logo">
          {/* Company Logo */}
          <img src={CompanyLogo} alt="Company Logo" />
        </div>

        {/* Hamburger Icon Button */}
        <button
          className="hamburger-icon"
          onClick={toggleMenu}
          aria-label="Toggle Navigation"
        >
          <img src={HamburgerIconImg} alt="Menu" className="hamburger-img" />
        </button>
      </div>

      <nav className={`header-nav ${isMenuOpen ? "nav-open" : ""}`}>
        <ul className="nav-list">
          <li className="nav-item">
            <a
              href="#projects" // Link to the 'projects' section
              className="nav-link"
              onClick={(e) => handleNavLinkClick(e, "projects")} // Pass event and ID
            >
              Projects
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#contact" // Link to the 'contact' section
              className="nav-link"
              onClick={(e) => handleNavLinkClick(e, "contact")} // Pass event and ID
            >
              Contact
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#about" // Link to the 'about' section
              className="nav-link"
              onClick={(e) => handleNavLinkClick(e, "about")} // Pass event and ID
            >
              About Us
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
